import { ReactNode } from 'react'
import { Position } from '../../../types/state'
import BigGif, {
    type ImageData,
} from '../../components/presentation/ChatImages/Gifs/BigGif'
import MinimizeUserBroadcastConfirmation from '../../components/presentation/Modals/Dialogs/MinimizeUserBroadcastConfirmation'
import { ModalKind } from '../../constants/enums'
import { locales } from '../../locales/en'
import { getLens } from '../../mfcLogic/lens'
import { fill } from '../../utilities/string'
import { setModal, setShowModal } from '../internal/modals'

type ConfirmationProps = {
    title?: string
    message?: ReactNode
    onOk?: (e?) => any
    onCancel?: (e?) => any
    cancel?: boolean
    ok?: boolean
}

export const showConfirmation = (show: boolean, immediate = false) =>
    setShowModal(ModalKind.Confirmation, show, immediate)

// this is primarily for ChatActionsBar at the moment
// - we should prefer to create specific functions
export const openConfirmation = ({
    title = null,
    message,
    onOk,
    onCancel,
    cancel = false,
    ok = true,
}: ConfirmationProps) => {
    setModal(ModalKind.Confirmation, {
        title,
        message,
        onOk,
        onCancel,
        cancel,
        ok,
        show: true,
    })
}

export const openDeleteAllConfirmation = (onOk: (e?) => any) => {
    setModal(ModalKind.Confirmation, {
        title: 'Clear Message List',
        message:
            'Are you sure that you want the current list of messages cleared?',
        onOk,
        cancel: true,
        show: true,
    })
}

export const openGifInsertionConfirmation = (
    onOk: (e?) => any,
    stagedImage: ImageData,
) => {
    setModal(ModalKind.Confirmation, {
        title: locales.chatImages.insertThisImage,
        message: <BigGif imageData={stagedImage} />,
        onOk,
        cancelLabel: 'No',
        okLabel: 'Yes',
        cancel: true,
        show: true,
    })
}

export const openWatchMemberWebcamConfirmation = (
    name: string,
    onOk: () => void,
    onCancel?: () => void,
) => {
    setModal(ModalKind.Confirmation, {
        show: true,
        title: locales.members.watchConfirm.title,
        message: fill(locales.members.watchConfirm.message, { name }),
        onOk,
        onCancel,
        okLabel: locales.members.watchConfirm.ok,
        cancelLabel: locales.members.watchConfirm.cancel,
        cancel: true,
    })
}

export const openHideModelConfirmation = () => {
    setModal(ModalKind.Confirmation, {
        show: true,
        title: locales.menu.modelHiddenTitle,
        message: locales.menu.modelHiddenMessage,
        ok: true,
    })
}

export const openStopUserBroadcastingConfirmation = (
    onOk: () => void,
    minimize?,
    message = locales.userBroadcast.confirmationStopBroadcast,
) => {
    setModal(ModalKind.Confirmation, {
        show: true,
        message: minimize ? <MinimizeUserBroadcastConfirmation /> : message,
        onOk,
        cancelLabel: minimize ? 'No' : null,
        okLabel: 'Yes',
        cancel: true,
    })
}

export const openQuickMenu = (
    id,
    position: Position,
    elevated = false,
    modelId?: number,
) => {
    getLens()?.ModelMenu_Click({ quickMenu: true })
    setModal(ModalKind.QuickMenu, {
        show: true,
        id,
        position,
        elevated,
        modelId,
    })
}

export const closeQuickMenu = (immediate = false) => {
    // safeTransition(() => {
    setShowModal(ModalKind.QuickMenu, false, immediate)
    // })
    // setShowModal(ModalKind.Confirmation, false, immediate)
}
